import React from 'react';

export function useIsPreferenceInitialized(preference) {
  const [isInitialized, setIsInitialized] = React.useState(false);

  React.useEffect(() => {
    preference.initialize().then(() => {
      setIsInitialized(true);
    });
  }, [preference]);

  return isInitialized;
}
